import { useBillingServiceStore } from '@billing/AppProvider'
import ReportType from '@billing/app/models/report-type.enum'
import { AlwaysHoveredOutlinedButton } from '@billing/components/button/AlwaysHoveredOutlinedButton'
import { Receipt } from '@mui/icons-material'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline'
import { Alert, Grid, Stack, Typography, styled } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { GeneralIcon, VesselIcon, YardIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReportNavigationButtonContainer } from './ReportNavigationButtonContainer'

const ReportTypeSelectButtonContent = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  width: theme.spacing(20),
  height: theme.spacing(12),
}))

export const ReportTypesContainer = observer(() => {
  const { reportsUIStore } = useBillingServiceStore()
  const { t } = useTranslate()

  const reportTypeButton = (reportType: ReportType, reportIcon: JSX.Element) => (
    <AlwaysHoveredOutlinedButton
      color='primary'
      variant='outlined'
      selected={reportType === reportsUIStore.currentType}
      error={!reportsUIStore.currentType && reportsUIStore.nextButtonWasBlocked ? 'true' : 'false'}
      onClick={() => reportsUIStore.setType(reportType)}
    >
      <ReportTypeSelectButtonContent direction='column' alignItems='center'>
        {reportIcon}
        <Typography variant='body2' color='black'>
          {t(reportType)}
        </Typography>
      </ReportTypeSelectButtonContent>
    </AlwaysHoveredOutlinedButton>
  )

  return (
    <>
      {!reportsUIStore.currentType && reportsUIStore.nextButtonWasBlocked && (
        <Alert severity='error'>
          {t(
            'pleaseSelectADataTypeFromTheFollowingList',
            'Please select a data type from the following list',
          )}
        </Alert>
      )}
      <Grid container spacing={2}>
        <Grid>{reportTypeButton(ReportType.VesselList, <VesselIcon color='action' />)}</Grid>
        <Grid>{reportTypeButton(ReportType.Storage, <YardIcon color='action' />)}</Grid>
        <Grid>{reportTypeButton(ReportType.Containers, <GeneralIcon color='action' />)}</Grid>
        <Grid>{reportTypeButton(ReportType.CustomerBilling, <Receipt color='action' />)}</Grid>
        <Grid>{reportTypeButton(ReportType.GCStoragePreBilling, <Receipt color='action' />)}</Grid>
        <Grid>{reportTypeButton(ReportType.GCServicesPreBilling, <Receipt color='action' />)}</Grid>
        <Grid>
          {reportTypeButton(ReportType.HandlingServicesReport, <Receipt color='action' />)}
        </Grid>
        {
          <Grid>
            {reportTypeButton(
              ReportType.DeliveryNote,
              <DriveFileRenameOutlineIcon color='action' />,
            )}
          </Grid>
        }
        {/* <Grid>{reportTypeButton(ReportType.BillableItemsReport, <Receipt color='action' />)}</Grid> */}
      </Grid>
      <ReportNavigationButtonContainer disableNext={!reportsUIStore.currentType} />
    </>
  )
})
